import { Component } from "@angular/core";

@Component({
    selector: "icon-close-modal",
    templateUrl: "./close_modal.svg",
    standalone: false
})
export class CloseModalIconComponent {}
